import { render, staticRenderFns } from "./cocal-match-list.vue?vue&type=template&id=119fa707&"
import script from "./cocal-match-list.vue?vue&type=script&lang=js&"
export * from "./cocal-match-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports